import { Toast } from "@swivu/shared-ui";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

type MessageKeys = {
  [key: string]: string;
};

const messageKeys: MessageKeys = {
  "Failed to fetch":
    "Failed to fetch data. Your internet may be down. Please try again later.",
  Unauthorized: "Please log in."
};

interface ZodIssue {
  code: string;
  expected: string;
  message: string;
  path: string[];
  received: string;
}

const redirectToLoginIfUnauthorized = (error: Error) => {
  console.log({ error });
  const [status] = error.message.split(":");
  if (status === "401") {
    // logic to redirect here
  }
};

const parseZodError = (error: Error): ZodIssue[] | null => {
  try {
    return JSON.parse(error.message) as ZodIssue[];
  } catch {
    return null;
  }
};

const handleError = (error: unknown) => {
  if (error instanceof Error) {
    redirectToLoginIfUnauthorized(error);

    const zodErrors = parseZodError(error);
    if (zodErrors?.length) {
      const messages = zodErrors.map(
        (issue) =>
          messageKeys[issue.message] ??
          `${issue.code} for ${issue.path.join(" -> ")}.  Expected ${
            issue.expected
          } but received  ${issue.received}. Message ${issue.message}`
      );
      Toast.toast({
        title: `Response error\n${messages.join(", ")}`,
        description: `We are aware of it and are working on it.`
      });
    } else {
      const [status, message] = error.message.split(":");
      if (Number(status) === 401) {
        window.location.href = `/login?redirect=${encodeURIComponent(
          window.location.pathname
        )}`;
      } else if (Number(status) === 403) {
        window.location.href = `/notEnabled`;
      } else if (Number(status) > 400) {
        Toast.toast({
          title: `${status} error\n${messageKeys[message] ?? message}`,
          description: `We are aware of the error and are working on it.`
        });
      }
    }
  }
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleError
  }),
  mutationCache: new MutationCache({
    onError: handleError
  })
});

export { queryClient };
